import { Button, Divider, ModalBody, ModalFooter, useDisclosure, useToast } from "@chakra-ui/react";
import { Alert, Form, Icon, Modal } from "components";
import { API } from "config";
import { useWithdraw } from "hooks";
import { useState } from "react";
import { Authenticate } from "screens";

export default function Send({ data, ...props }){

    const toast = useToast()
    const withdraw = useWithdraw(data?.id)
    const auth = useDisclosure()
    const [ file, setFile ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!file) return
        setLoading(true)

        try{
            await API.post(`/withdraws/${withdraw.data?.id}/done`, { receipt: file, _method: 'put' }, { headers: { "Content-Type": "multipart/form-data" } })
            withdraw.refetch()
            props.onClose()
        }catch({ response }){
            toast({ title: "Não foi possível confirmar o envio do saque", description: response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Modal title={`Enviar pedido de saque #${withdraw.data?.cod}`} loading={loading} {...props}> 
        <ModalBody fontSize="sm">
            Aqui você irá confirmar o transferência do valor do saque para a conta bancária do cliente. Por favor, anexe um comprovante de pagamento.

            <Divider my={4} />

            <Form.File 
                label="Anexar comprovante de transferência"
                onChange={setFile}
            />

            <Alert mt={4} children="O comprovante de pagamento não é exibido ou enviado para o cliente. Serve a apenas para fins de controle interno." />
        </ModalBody>
        <ModalFooter>
            <Button isDisabled={!file} isLoading={loading} size="sm" leftIcon={<Icon name="check" />} onClick={auth.onOpen} children="Confirmar envio" />
        </ModalFooter>
    </Modal>

    <Authenticate onSuccess={handleSubmit} {...auth} />
    </>
    )
}